/**
 * WEB-3447, заход 2 — ЛЕНИВЫЙ КУСОК градиентов бренда и дополнительных
 * переменных стиль-пака (решение владельца 17.10.2026, вариант «б»: «градиенты
 * и дополнительные переменные стиль-пака — в ленивый кусок, только для
 * воронки, которой они нужны»; потолок веса первого экрана не поднимать).
 *
 * Своего кода здесь нет — только прежние функции одним объектом:
 *  - градиенты бренда (`gradient.ts`: градиент поля автора, цвет текста
 *    поверх него, роли → переменные корня воронки);
 *  - дополнительные переменные пака (`stylePackExtraVars.ts`: появление
 *    экрана, поля на телефоне, интерлиньяж и трекинг, десктопная типографика);
 *  - интерлиньяж и трекинг заголовков из пака (`subTitleTypeStyle.ts`).
 *
 * Плеер берёт их у двери `styleKitDoor.ts`; покупатель получает этот файл,
 * только когда воронке он нужен (`funnelNeedsStyleKit`). Импортировать этот
 * файл статически можно только кабинету (`main.tsx`) и тестам: статический
 * импорт из плеера вернул бы кусок в первый экран — это краснит
 * `FIRST_SCREEN_DEFERRED_MODULES` сторожа сборки.
 */
import {
  authorGradient,
  gradientTextColor,
  gradientsToStyle,
} from './gradient';
import { stylePackExtraVars } from './stylePackExtraVars';
import { LAZY_THEMES } from './themeCatalog';
import {
  subTitleTypeStyle,
  titleLineHeight,
} from '@/components/editor/subTitleTypeStyle';

export const STYLE_KIT = {
  authorGradient,
  gradientTextColor,
  gradientsToStyle,
  stylePackExtraVars,
  titleLineHeight,
  subTitleTypeStyle,
  // WEB-3447, заход 3: темы, что едут куском (тема «Blue Gradient»).
  lazyThemes: LAZY_THEMES,
};

export type StyleKit = typeof STYLE_KIT;
